import { render, staticRenderFns } from "./googleRating.vue?vue&type=template&id=1e849cf4&scoped=true"
import script from "./googleRating.vue?vue&type=script&lang=js"
export * from "./googleRating.vue?vue&type=script&lang=js"
import style0 from "./googleRating.vue?vue&type=style&index=0&id=1e849cf4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e849cf4",
  null
  
)

export default component.exports